module.exports = __webpack_public_path__ + "static/media/matplotlib.ae7649bf.jpg";